import { render, staticRenderFns } from "./selfAssessmentFormDetail.vue?vue&type=template&id=315e9acc&scoped=true"
import script from "./selfAssessmentFormDetail.vue?vue&type=script&lang=js"
export * from "./selfAssessmentFormDetail.vue?vue&type=script&lang=js"
import style0 from "./selfAssessmentFormDetail.vue?vue&type=style&index=0&id=315e9acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e9acc",
  null
  
)

export default component.exports